/* ==========================================================================
   SANDBOX EXPANSION ENGINE (ts/sandbox-engine.ts)
   ========================================================================== */

import { TypeSmartShortcuts } from './shortcuts-data';

export function initSandboxEngine(): void {
  const sandboxInput = document.getElementById('sandboxInput') as HTMLTextAreaElement | null;
  const expansionPreview = document.getElementById('expansionPreview') as HTMLElement | null;
  const chipButtons = document.querySelectorAll<HTMLButtonElement>('.chip-btn');

  function processExpansion(text: string): string {
    if (!text || !text.trim()) {
      return '<span style="color: var(--color-text-dim);">Type a shortcut (e.g. <code>rfp</code>, <code>email</code>, <code>thanks</code>) or click a preset above to see instant expansion...</span>';
    }

    let processedText = text;

    Object.keys(TypeSmartShortcuts).forEach((key: string) => {
      if (processedText.includes(key)) {
        const expandedValue = TypeSmartShortcuts[key];
        const highlightedExpansion = `<span class="expanded-text-highlight">${expandedValue.replace(/\n/g, '<br>')}</span>`;
        const regex = new RegExp(key, 'g');
        processedText = processedText.replace(regex, highlightedExpansion);
      }
    });

    return processedText.replace(/\n/g, '<br>');
  }

  if (sandboxInput && expansionPreview) {
    sandboxInput.addEventListener('input', (e: Event) => {
      const target = e.target as HTMLTextAreaElement;
      expansionPreview.innerHTML = processExpansion(target.value);
    });

    chipButtons.forEach((btn: HTMLButtonElement) => {
      btn.addEventListener('click', () => {
        const shortcutTag = btn.getAttribute('data-shortcut');
        if (shortcutTag) {
          sandboxInput.value = `Testing shortcut ${shortcutTag} live in action!`;
          expansionPreview.innerHTML = processExpansion(sandboxInput.value);
        }
      });
    });
  }
}
